export default __webpack_public_path__ + "static/media/complementary--distance--g1.108230dd.png";